import { render, staticRenderFns } from "./InfoboxRequest.vue?vue&type=template&id=ca154f1c&scoped=true&"
import script from "./InfoboxRequest.vue?vue&type=script&lang=js&"
export * from "./InfoboxRequest.vue?vue&type=script&lang=js&"
import style0 from "./InfoboxRequest.vue?vue&type=style&index=0&id=ca154f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca154f1c",
  null
  
)

export default component.exports